import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const MyModal = (props) => {
    const handleClose = () => props.handleModalClose();
    const handleSubmit = () => props.handleModalSubmit(props.cat ? props.cat.id : null);

    return (
        <Modal show={props.showModal} onHide={handleClose} centered>
            <Modal.Header closeButton style={{ borderBottom: '1px solid #e2e8f0', padding: '16px 24px' }}>
                <Modal.Title style={{ fontSize: '1.15rem', fontWeight: '700', color: '#0f172a' }}>
                    Confirm Action
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '24px', color: '#475569', fontSize: '0.95rem' }}>
                {props.modalBody}
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e2e8f0', padding: '14px 24px' }}>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleSubmit}>
                    Confirm Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MyModal;